import { PacksClient } from '../types'

export const refreshPack = (base: PacksClient) => (packId: string, hash: string, time: string) =>
  base.requester.get<any>(`/${packId}/check/${hash}/${time}`)
